export default __webpack_public_path__ + "static/media/spinning.c3defd7b.png";